import { Typography, Box } from "@mui/material";
import { HashLink as Link } from "react-router-hash-link";
import { motion } from "framer-motion";

export default function MainPage() {
  return (
    <section id="">
      <Box
        id="top"
        display="grid"
        gridTemplateColumns={{ xs: "1fr", md: "1fr 2fr" }}
        gap={5}
        height="100vh"
      >
        <Box
          sx={{
            alignSelf: "center",
            justifySelf: "center",
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          <Typography letterSpacing={2} fontSize={15} fontWeight={600}>
            POLINA CHEBANENKO
          </Typography>
          <Typography fontSize={13}>Full Stack Software Engineer</Typography>
        </Box>
        <Box
          sx={{
            alignSelf: "center",
            display: { xs: "none", md: "block" },
          }}
        >
          <Link
            smooth
            to="/#about"
            style={{ color: "inherit", textDecoration: "none" }}
          >
            <motion.div whileHover={{ scale: 0.95 }} whileTap={{ scale: 0.9 }}>
              <Typography variant="h2" fontFamily="Canopee">
                About
              </Typography>
            </motion.div>
          </Link>
          <Link
            smooth
            to="/#engineer"
            style={{ color: "inherit", textDecoration: "none" }}
          >
            <motion.div whileHover={{ scale: 0.95 }} whileTap={{ scale: 0.9 }}>
              <Typography variant="h2" fontFamily="Canopee">
                Fun
              </Typography>
            </motion.div>
          </Link>
          <Link
            smooth
            to="/#Work"
            style={{ color: "inherit", textDecoration: "none" }}
          >
            <motion.div whileHover={{ scale: 0.95 }} whileTap={{ scale: 0.9 }}>
              <Typography variant="h2" fontFamily="Canopee">
                Work
              </Typography>
            </motion.div>
          </Link>
          <Link
            smooth
            to="/#contact"
            style={{ color: "inherit", textDecoration: "none" }}
          >
            <motion.div whileHover={{ scale: 0.95 }} whileTap={{ scale: 0.9 }}>
              <Typography variant="h2" fontFamily="Canopee">
                Contact
              </Typography>
            </motion.div>
          </Link>
        </Box>
      </Box>
    </section>
  );
}
